
export const allUnits = [ '%', 'cm', 'mm', 'rem', 'em', 'ex', 'in', 'pc', 'pt', 'px', 'vh', 'vw', 'vmin', 'vmax', 'fr' ];
export const getUnit = str => allUnits.filter( unit => str.indexOf( unit ) > -1 );
export const stripUnit = str => {
    getUnit( str ).forEach( unit => {
        str = str.replace( unit, '' );
    });
    return str;
};



// WEBPACK FOOTER //
// src/client/helpers/common/cssUnit.js